import React from "react";
import { useActor } from "@xstate/react";
import AutoCompleteInput from "../AutoCompleteInput";
import { Button } from "../SignUpButton";
import { useSignUpMachine } from "../../context/SignUpMachineContext";
import { SignUpFormField } from "../../constants/signup-form-field.enum";
import { BalancedStepTitle } from "../BalancedStepTitle";
import { BalancedStepSubtitle } from "../BalancedStepSubtitle";

const CompanyStep: React.FC = () => {
  const machine = useSignUpMachine();
  const [state, send] = useActor(machine);
  const { formData } = state.context;

  const companyValue = formData[SignUpFormField.Company];

  const handleChange = (value: any) => {
    send({
      type: "UPDATE_FORM",
      data: { [SignUpFormField.Company]: value },
    });
  };

  const handleSubmit = () => {
    send({ type: "NEXT" });
  };

  const canProceed = Boolean(companyValue?.label);

  return (
    <>
      <div className="tw-flex tw-flex-col tw-items-center tw-space-y-1 tw-text-center">
        <BalancedStepTitle title="Sign up today" />
        <BalancedStepSubtitle
          subtitle="Start by searching for your business name. If it's not listed,
          you'll be able to add it manually."
        />
      </div>

      <div className="tw-space-y-4">
        <label
          htmlFor={SignUpFormField.Company}
          className="tw-block tw-text-sm tw-text-gray-800"
        >
          Business Name
        </label>
        <AutoCompleteInput
          inputId={SignUpFormField.Company}
          value={companyValue}
          placeholder="Search for your business"
          onChange={handleChange}
          onSelect={handleSubmit}
        />
      </div>

      <div className="tw-flex tw-justify-between tw-items-center">
        <Button
          onClick={handleSubmit}
          disabled={!canProceed}
          size="fat"
          className="tw-uppercase tw-tracking-widest tw-w-full tw-flex tw-py-4 tw-items-center tw-gap-2 tw-text-white"
        >
          <span>Next</span>
        </Button>
      </div>
    </>
  );
};

export default CompanyStep;
